import React from 'react'
import styles from './FieldsRow.module.css'

export function FieldsRow ({ children }) {
  return <div className={styles.root}>{children}</div>
}
